<template>
  <va-card>
    <!-- Header slot replaces the old :title prop -->
    <template #header>
      {{ $t('dashboard.member-details') }}
    </template>

    <va-tabs grow v-model="tabsState">
      <va-tab>
        {{ $t('dashboard.tabs.billingAddress.bio-data') }}
      </va-tab>
      <va-tab>
        {{ $t('dashboard.tabs.bankDetails.title') }}
      </va-tab>
    </va-tabs>

    <va-separator />

    <component :is="tabs[tabsState]" @submit="submit" />
  </va-card>
</template>

<script>
import BillingAddressTab from './dashboard-tabs/BillingAddressTab'
import BankDetailsTab from './dashboard-tabs/BankDetailsTab'

export default {
  name: 'DashboardTabs',
  components: {
    BillingAddressTab,
    BankDetailsTab,
  },
  data () {
    return {
      tabsState: 1,
      tabs: [
        'BillingAddressTab',
        'BankDetailsTab',
      ],
    }
  },
  methods: {
    submit (data) {
      this.$emit('submit', data)
    },
  },
}
</script>
